module.exports = __webpack_public_path__ + "static/img/francesca_beautiful.e77e862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/francesca_beautiful.png
// module id = 0Te3
// module chunks = 0